export const TRANSLATION = `builder.auto_apply.resume_select`
